module.exports = __webpack_public_path__ + "img/logo-training.fb01f972.svg";